export const BATCH_JOB_ENTITY_GROUP_NAME = 'batchJobs';
export const BATCH_JOB_ENTITIY_ID_ATTRIBUTE = 'jobId';
export const BATCH_ENTITY_GROUP_NAME = 'batches';
export const BATCH_ENTITY_ID_ATTRIBUTE = 'fulfillmentPlanSetId';

export const BATCH_JOB_STATUS_COMPLETED = 'BATCH_JOB_STATUS_COMPLETED';
export const BATCH_JOB_STATUS_ERRORED = 'BATCH_JOB_STATUS_ERRORED';
export const BATCH_JOB_STATUS_PROCESSING = 'BATCH_JOB_STATUS_PROCESSING';
